import { IndustryTemplate } from '@/components';
import { treeServiceContent } from '@/data/industries/tree-service';

export function TreeServicePage() {
  return <IndustryTemplate content={treeServiceContent} />;
}
